import { makeStyles } from "@mui/styles";
import backgroundImage from "../../assets/images/admin-icon-2/bg-black.png";
import { colors } from "../../theme/colors";
import { fonts } from "../../theme/fonts";

const { Grey } = colors;
const { text } = fonts;

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "#000",
    backgroundSize: "cover",
    backgroundImage: `url(${backgroundImage})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100vw",
    minHeight: "100vh",
  },
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0, 0, 0, 0.8)", // Dark overlay to emphasize loading
    zIndex: 1000, // Ensure it stays on top
    color: "#FFFFFF",
    fontSize: "18px",
  },
  formContainer: {
    width: "100%",
    maxWidth: 400,
    borderRadius: "8px",
    padding: "24px",
  },
  logoContainer: {
    textAlign: "center",
    marginBottom: 32,
  },
  logoImage: {
    width: 80,
  },
  playerdexLogo: {
    width: 80,
  },
  descriptionText: {
    ...text.md.normal,
    color: Grey[500],
    textAlign: "center",
    marginBottom: 12,
  },
  formGroup: {
    marginBottom: 28,
  },
  inputField: {
    ...text.sm.medium,
    backgroundColor: "#182229 !important",
    color: "#FFFFFF !important",
    borderRadius: "8px !important",
    border: "1px solid #212D38 !important",
    padding: "10px !important",
    height: 60,
  },
  signInButton: {
    fontSize: "16px !important",
    color: "#1F2831 !important",
  },
});

export default useStyles;
